import {SuiModalComponent} from '@angular-ex/semantic-ui';
import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {firstValueFrom} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {PopulatedUser} from '../../../../core/models/users/users.model';
import {KcAdminCliService} from '../../../../core/services/kc-admin-cli/kc-admin-cli.service';
import {ToastService} from '../../../../core/services/toast/toast.service';
import {UsersService} from '../../../../core/services/users/users.service';
import {UserNewsletterFormValues} from '../../../../shared/forms/user-newsletter-form/user-newsletter-form.component';
import {UserFormValues} from '../../../../shared/forms/user-profile-form/user-profile-form.component';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.css'],
  standalone: false,
})
export class EditUserComponent implements OnInit {
  user?: PopulatedUser<'institution'>;

  constructor(
    private usersService: UsersService,
    private kcAdminService: KcAdminCliService,
    private toastService: ToastService,
    protected route: ActivatedRoute,
    protected router: Router,
  ) {
  }

  ngOnInit() {
    this.route.params.pipe(
      switchMap(({id}) => this.usersService.getOne(id, ['institution'])),
    ).subscribe(user => {
      this.user = user;
    });
  }

  async save(profileForm: UserFormValues, newsletterForm: UserNewsletterFormValues) {
    const {_id, kcId} = this.user!;

    const {receiveInternalMessages, ...newsletter} = newsletterForm;
    this.usersService.updateOne(_id, {
      ...profileForm,
      receiveInternalMessages,
      abonnement: {
        ...this.user!.abonnement,
        ...newsletter,
      },
    }, ['institution']).subscribe(user => {
      this.toastService.success('Nutzerprofil bearbeitet', `Der Nutzer "${user.firstname} ${user.lastname}" wurde erfolgreich bearbeitet.`);
      this.router.navigate(['../..'], {relativeTo: this.route});
    }, error => {
      this.toastService.error('Nutzerprofil nicht bearbeitet', `Der Nutzer "${profileForm.firstname} ${profileForm.lastname}" konnte nicht bearbeitet werden.`, error);
    });

    const kcUser = await firstValueFrom(this.kcAdminService.getUser(kcId));
    if (kcUser.email !== profileForm.email) {
      // update user profile in keycloak
      kcUser.email = profileForm.email;
      kcUser.username = profileForm.email;
      this.kcAdminService.updateOneUser(kcId, kcUser).subscribe(() => {
        this.toastService.success('Nutzer-Email bearbeitet', `Der Emailadresse von "${kcUser.email}" wurde erfolgreich geändert.`);
      }, error => {
        this.toastService.error('Nutzer-Email nicht bearbeitet', `Die Emailadresse von "${kcUser.email}" konnte nicht geändert werden.`, error);
      });
    }

    // TODO check if role was changed
    this.kcAdminService.addUserToGroup(kcId, profileForm.role).subscribe(() => {
      this.toastService.success('Nutzerrolle bearbeitet', `Die Rolle von "${kcUser.email}" wurde erfolgreich geändert.`);
    }, error => {
      this.toastService.error('Nutzerrolle nicht bearbeitet', `Die Rolle von "${kcUser.email}" konnte nicht geändert werden.`, error);
    });
  }
}
